import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import {
  Link,
  LinkIcon,
} from '../../components'
import Styles from './IyvListFilters.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListSearchSettingsButton extends Component {
  static propTypes = {
    currentTutorial: PropTypes.number,
    showTutorial: PropTypes.bool,
    clickCloseTutorial: PropTypes.func,
    clickToggleFilters: PropTypes.func,
    showFilters: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return (
      <div
        styleName={
          this.props.currentTutorial === 2 && this.props.showTutorial ?
            'settings-wrap tutorial-highlight-filters-wrap' :
            'settings-wrap'
        }
        onClick={this.props.clickCloseTutorial}
      >
        <button
          styleName='adjust-filters'
          onClick={this.props.clickToggleFilters}
          role='button'
          tabIndex='0'
          title='Adjust filters'
        >
          <span styleName='adjust-filters-text'>
            <LinkIcon nospace faclass='fa-sliders' />
            &nbsp;
            Search settings
            <LinkIcon
              faclass={
                this.props.showFilters ?
                  'fa-angle-up' :
                  'fa-angle-down'
              }
            />
          </span>
        </button>

        { /* <Link
          to={config.routes.howitworks+'#spreadsheet'}
          title='Download spreadsheet'
          xstrong
        >
          Download spreadsheet
          <LinkIcon faclass='fa-download'/>
          <LinkIcon faclass='fa-file-excel-o'/>
        </Link> */ }
      </div>
    )
  }
}